// actionTypes.js
export const SET_VALUE_DOCUMENTATION_GENERALES = "SET_VALUE_DOCUMENTATION_GENERALES";
export const SET_CATEGORIE_DOCUMENTATION_GENERALES = "SET_CATEGORIE_DOCUMENTATION_GENERALES";
export const SET_TYPE_DOCUMENTATION_GENERALES = "SET_TYPE_DOCUMENTATION_GENERALES";
export const SET_ANNEE_DOCUMENTATION_GENERALES = "SET_ANNEE_DOCUMENTATION_GENERALES";
export const SET_CURRENT_PAGE_DOCUMENTATION_GENERALES = "SET_CURRENT_PAGE_DOCUMENTATION_GENERALES";
export const SET_ORDER_DOCUMENTATION_GENERALES = "SET_ORDER_DOCUMENTATION_GENERALES";
export const SET_SORT_FIELD_DOCUMENTATION_GENERALES = "SET_SORT_FIELD_DOCUMENTATION_GENERALES";
